import { forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';

import {
  AlertColor,
  AlertDirection,
  AlertProps,
  AlertVariant,
} from './types';

const colorClasses: Record<AlertColor, string> = {
  default: '',
  info: 'alert-info',
  success: 'alert-success',
  warning: 'alert-warning',
  error: 'alert-error',
};

const variantClasses: Record<AlertVariant, string> = {
  default: '',
  outline: 'alert-outline',
  dash: 'alert-dash',
  soft: 'alert-soft',
};

const directionClasses: Record<AlertDirection, string> = {
  vertical: 'alert-vertical',
  horizontal: 'alert-horizontal',
};

export const Alert = forwardRef<HTMLDivElement, AlertProps>(
  (
    {
      className,
      color = 'default',
      variant = 'default',
      direction,
      role = 'alert',
      children,
      ...props
    },
    ref,
  ) => {
    const classes = twMerge(
      'alert',
      colorClasses[color],
      variantClasses[variant],
      direction ? directionClasses[direction] : '',
      className,
    );

    return (
      <div ref={ref} role={role} className={classes} {...props}>
        {children}
      </div>
    );
  },
);

Alert.displayName = 'Alert';
